<div class="mt-0 pt-0 ms-1 me-1" style="background-color: #FBFBFB !important;">
    <header>
        <!-- <div class="text-center mt-3">
        <img src="assets/images/logo-checkout.png" alt="Image" style="width: 7.776rem;" />
    </div> -->
        <h1 class="main-text checkout-title text-center mt-5">Política de Tratamiento y Protección de Datos de RiverApp
        </h1>
    </header>

    <main class="container">
        <section>
            <p>RiverApp valora y protege la privacidad de sus usuarios. Esta política describe cómo recopilamos,
                utilizamos,
                almacenamos y protegemos tus datos personales, en cumplimiento con la Ley 1581 de 2012 de Colombia y el
                Decreto 1377 de 2013.</p>
        </section>

        <section class="mt-4">
            <h2 class="mt-3 font-size-terms">1. Datos que Recopilamos</h2>
            <p class="ms-5">RiverApp recopila los siguientes datos personales para la prestación de sus servicios:</p>
            <h3 class="font-size-terms">Para Compradores:</h3>
            <ul>
                <li>Nombre completo.</li>
                <li>Número de teléfono.</li>
                <li>Dirección.</li>
                <li>Contraseña.</li>
            </ul>
            <h3 class="font-size-terms">Para Vendedores:</h3>
            <ul>
                <li>Nombre completo del administrador de la tienda.</li>
                <li>Nombre de la tienda.</li>
                <li>Descripción de la tienda.</li>
                <li>Departamento y ciudad.</li>
                <li>Dirección.</li>
                <li>Teléfono de contacto.</li>
                <li>Correo electrónico.</li>
                <li>Contraseña.</li>
                <li>Logo de la tienda.</li>
            </ul>
        </section>

        <section>
            <h2 class="mt-3 font-size-terms">2. Uso de los Datos</h2>
            <p class="ms-5">Utilizamos los datos recopilados para los siguientes fines:</p>
            <ul>
                <li class="ms-5">Gestionar transacciones entre compradores y vendedores.</li>
                <li class="ms-5">Garantizar la entrega de productos adquiridos a través de la App.</li>
                <li class="ms-5">Enviar notificaciones relacionadas con el uso de la App, como actualizaciones o
                    promociones.</li>
                <li class="ms-5">Administrar y personalizar la experiencia del usuario en la plataforma.</li>
            </ul>
        </section>

        <section>
            <h2 class="mt-3 font-size-terms">3. Almacenamiento y Retención de Datos</h2>
            <p class="ms-5">Los datos personales se almacenan en bases de datos no relacionales (MongoDB) y servidores
                seguros en la nube
                proporcionados por AWS. La información se retiene indefinidamente, a menos que el usuario solicite su
                eliminación desde el módulo de perfil dentro de la App.</p>
        </section>

        <section>
            <h2 class="mt-3 font-size-terms">4. Derechos de los Usuarios</h2>
            <p class="ms-5">Los usuarios de RiverApp tienen los siguientes derechos respecto a sus datos personales:</p>
            <ul>
                <li class="ms-5"><strong>Acceso:</strong> Solicitar información sobre los datos almacenados.</li>
                <li class="ms-5"><strong>Rectificación:</strong> Corregir errores en los datos personales
                    proporcionados.</li>
                <li class="ms-5"><strong>Eliminación:</strong> Solicitar la eliminación de los datos desde el módulo de
                    perfil.</li>
                <li class="ms-5"><strong>Revocación del consentimiento:</strong> Retirar el consentimiento para el
                    tratamiento de datos
                    en cualquier momento.</li>
            </ul>
            <p class="ms-5">Para ejercer estos derechos, puedes contactarnos al correo <a
                    href="mailto:riverappoficial@gmail.com">riverappoficial&#64;gmail.com</a> o al teléfono +57 301
                9854097.</p>
        </section>

        <section>
            <h2 class="mt-3 font-size-terms">5. Seguridad de los Datos</h2>
            <p class="ms-5">RiverApp implementa medidas de seguridad avanzadas para proteger los datos de sus usuarios:
            </p>
            <ul>
                <li class="ms-5">Encriptación de datos sensibles.</li>
                <li class="ms-5">Acceso restringido a personal autorizado.</li>
                <li class="ms-5">Auditorías periódicas de seguridad para garantizar el cumplimiento de los estándares.
                </li>
            </ul>
        </section>

        <section>
            <h2 class="mt-3 font-size-terms">6. Compartición de Datos con Terceros</h2>
            <p class="ms-5">RiverApp podrá compartir datos personales con terceros en los siguientes casos:</p>
            <ul>
                <li class="ms-5"><strong>Pasarela de pago:</strong> Los datos necesarios para procesar transacciones
                    serán compartidos
                    con Wompi, bajo sus términos y políticas de privacidad.</li>
                <li class="ms-5"><strong>Servicios adicionales:</strong> Proveedores que ayuden a mejorar la experiencia
                    del usuario
                    (e.g., notificaciones o análisis de datos).</li>
            </ul>
            <p class="ms-5">RiverApp exige a estos terceros garantizar la confidencialidad y seguridad de los datos
                compartidos.</p>
        </section>

        <section>
            <h2 class="mt-3 font-size-terms">7. Modificaciones a la Política de Tratamiento de Datos</h2>
            <p class="ms-5">Esta política está sujeta a cambios. Notificaremos a los usuarios sobre cualquier
                actualización significativa
                mediante la App y otros medios de comunicación disponibles. Te recomendamos revisar esta política
                periódicamente para mantenerte informado sobre cómo protegemos tus datos personales.</p>
        </section>

        <section>
            <h2 class="mt-3 font-size-terms">8. Contacto</h2>
            <p class="ms-5">Si tienes preguntas sobre esta política de tratamiento de datos, puedes contactarnos en:</p>
            <ul>
                <li class="ms-5"><strong>Correo electrónico:</strong> <a
                        href="mailto:riverappoficial@gmail.com">riverappoficial&#64;gmail.com</a></li>
                <li class="ms-5"><strong>Teléfono:</strong> +57 301 9854097</li>
            </ul>
        </section>
    </main>

    <footer class="text-center">
        <p class="ms-5">&copy; 2025 RiverApp. Todos los derechos reservados.</p>
    </footer>
</div>